import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Login from '../../components/Login/Login';

function Loginpage() {
    return (
        <div>
        <Login/>
        </div>
    )
}

export default Loginpage
